import styled from "styled-components";

export const GenrealInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  padding: 10px 20px 40px 20px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
`;

export const Title = styled.h2`
  color: #00aeea;
  font-size: 16px;
  font-family: lato;
  text-transform: initial;
  padding-top: 10px
  line-height: 1;
  margin-top: 3px;
  font-weight: bold !important;
  padding-left: 10px;
  justify-self: auto;
`;

export const SubTitle = styled.div`
  justify-self: auto;
  color: #474747;
  font-size: 14px;
  font-weight: 400;
  padding-left: ${(props) => props.paddingLeft ?? "20px"};
  padding-right: 1.375rem;
  margin-bottom: ${(props) => props.marginBottom ?? "20px"};
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) =>
    props?.alignItems ? props.alignItems : "self-start"};
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: 1.25rem;
  font-weight: normal;
`;

export const MapContainer = styled.div`
  border-radius: 4px;
  position: relative;
  height: 300px;
  overflow: hidden;
  outline: none;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  margin: 0 1.375rem;
  width: 195%;
  border: solid 1px #00aeea;
`;

export const ContentInfo = styled.span`
  font-size: 14px;
  margin-bottom: 10px;
  color: #474747 !important;
`;
